import { MdOutlineVerified } from 'react-icons/md';
import Tooltip from '@/components/Tooltip';
import { useI18nText } from '@/lib/utils/i18nText';

/** 대시보드·결제·통계 등에서 공통으로 쓰는 채널 인증 배지용 최소 필드 */
export interface ChannelVerifiedBadgeChannel {
  type?: string;
  raw?: {
    verified?: boolean;
    isVerified?: boolean;
    broadcaster_type?: string;
  };
}

const VERIFIED_COLORS = {
  instagram: '#3897f0',
  tiktok: '#20D5EC',
  twitch: '#9148FF',
} as const;

export interface ChannelVerifiedBadgeProps {
  channel?: ChannelVerifiedBadgeChannel | null;
  /** 아이콘 크기(px). 기본 15 */
  iconSize?: number;
  /** 루트 래퍼에 추가 클래스 (레이아웃만, 색/형태는 공통 유지) */
  className?: string;
}

/**
 * Instagram / TikTok / Douyin / Twitch 파트너·제휴 인증 표시.
 * 스타일은 `components.css`의 `.channel-badge-wrap`, `.channel-badge--twitch` 사용.
 */
export default function ChannelVerifiedBadge({
  channel,
  iconSize = 15,
  className,
}: ChannelVerifiedBadgeProps) {
  const { t } = useI18nText();
  if (!channel) return null;
  const type = channel.type;
  const raw = channel.raw;
  if (!raw) return null;

  const wrapClass = ['channel-badge-wrap', className].filter(Boolean).join(' ');

  if (type === 'instagram' && raw.isVerified) {
    return (
      <Tooltip content={t('Verified Instagram', '인증된 Instagram')}>
        <span className={wrapClass}>
          <MdOutlineVerified color={VERIFIED_COLORS.instagram} size={iconSize} />
        </span>
      </Tooltip>
    );
  }
  if (type === 'tiktok' && raw.verified) {
    return (
      <Tooltip content={t('Verified TikTok', '인증된 TikTok')}>
        <span className={wrapClass}>
          <MdOutlineVerified color={VERIFIED_COLORS.tiktok} size={iconSize} />
        </span>
      </Tooltip>
    );
  }
  if (type === 'douyin' && raw.isVerified) {
    return (
      <Tooltip content={t('Verified Douyin', '인증된 Douyin')}>
        <span className={wrapClass}>
          <MdOutlineVerified color={VERIFIED_COLORS.tiktok} size={iconSize} />
        </span>
      </Tooltip>
    );
  }
  if (type === 'twitch') {
    if (raw.broadcaster_type === 'partner') {
      return (
        <Tooltip content={t('Twitch Partner', '트위치 파트너')}>
          <span className={wrapClass}>
            <MdOutlineVerified color={VERIFIED_COLORS.twitch} size={iconSize} />
          </span>
        </Tooltip>
      );
    }
    if (raw.broadcaster_type === 'affiliate') {
      return (
        <Tooltip content={t('Twitch Affiliate', '트위치 제휴')}>
          <i className="fa fa-handshake-o channel-badge channel-badge--twitch" />
        </Tooltip>
      );
    }
  }
  return null;
}
